import { DateTime } from 'luxon';

export const convertServerTimeToShortDate = (serverDate: string): string => DateTime.fromISO(serverDate).toFormat('dd/MM/yyyy');
